import { Injectable } from '@angular/core';
import { BaseService } from 'src/services/core/base/base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

const routes = {
  allCategories: 'menus/categories/all',
};

@Injectable({
  providedIn: 'root',
})
export class CategoriesService extends BaseService<any> {
  constructor(public http: HttpClient) {
    super(http);
  }

  getAllCategories(restaurantId: number): Observable<any> {
    return this.sendGet(
      this.baseUrl(`${routes.allCategories}/${restaurantId}`)
    );
  }
}
